import { Lock, Menu } from "@mui/icons-material";
import { AppBar, Box, IconButton, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import logoP from "../../assets/logos/logo-primary.svg";
import { selectIsLogin } from "../../features/authentication/services";
import { SelectLangs } from "../../features/langs/components";
import LogoBtn from "../button/LogoBtn";
import Sidebar from "./Sidebar";
import classes from "./TopNav.module.scss";
import UserNav from "./UserNav";

interface IProps {
    drawerWidth: number;
    sideBarOpen: boolean;
    handleSideBarOpen: () => void;
}

const TopNav = ({ drawerWidth, sideBarOpen, handleSideBarOpen }: IProps) => {
    const isLogin = useSelector(selectIsLogin);
    const navigate = useNavigate();

    return (
        <div id='sidebar-parent' className={classes.sidebarParent}>
            <AppBar
                position='fixed'
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                className={classes.appBar}
            >
                <Box className={classes.navBox}>
                    <IconButton
                        color='inherit'
                        aria-label='open drawer'
                        edge='start'
                        onClick={handleSideBarOpen}
                        sx={{
                            mr: 2,
                            display: { color: "#fff" },
                        }}
                    >
                        <Menu className={classes.filled} />
                    </IconButton>
                    <Box sx={{ flexGrow: 1 }}>
                        <div className={classes.logoWrapper}>
                            <LogoBtn logo={logoP} />
                        </div>
                    </Box>
                    <Box>
                        <Box>
                            <Stack flexDirection='row' className={classes.actionWrapper}>
                                <SelectLangs />
                                {isLogin ? (
                                    <UserNav />
                                ) : (
                                    <IconButton onClick={() => navigate("/login")} sx={{ px: 0 }}>
                                        <Lock
                                            sx={{
                                                color: "#fff",
                                                fontSize: 26,
                                            }}
                                        />
                                    </IconButton>
                                )}
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            </AppBar>

            <Sidebar
                navItems={[]}
                drawerWidth={drawerWidth}
                handleDrawerToggle={handleSideBarOpen}
                mobileOpen={sideBarOpen}
            />
        </div>
    );
};
export default TopNav;
